import { render } from "./StoreProductCardList.vue?vue&type=template&id=50cbac0c"
import script from "./StoreProductCardList.vue?vue&type=script&lang=js"
export * from "./StoreProductCardList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__